import { faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as Sentry from '@sentry/node';
import axios, { AxiosResponse } from 'axios';
import Cleave from 'cleave.js/react';
import React, { useEffect, useState } from 'react';
import {
  Button,
  Col,
  Form,
  ListGroup,
  Modal,
  Row,
  Toast,
} from 'react-bootstrap';
import { Menu, MenuItem, Typeahead } from 'react-bootstrap-typeahead';
import { useDispatch, useSelector } from 'react-redux';
import SyncLoader from 'react-spinners/SyncLoader';
import { useDebouncedCallback } from 'use-debounce';
import db from '../../SDKs/firebase/firebase';
import Section from '../../components/Section';
import { useFranchiseeContext } from '../../context/Franchisee';
import { SET_RESIDENCE, useLeadContext } from '../../context/Lead';
import usStates from '../../data/states_object.json';
import { setAddress, setBillingAddress } from '../../features/user/userSlice';
import franchisee from '../../sessions/franchisee';
import { pink500 } from '../../ui/colors';
import {
  validateAddressStringField,
  validateUSState,
  validateZipCode,
} from '../../utils/stringValidation';
import StateOptions from '../StateOptions';
import ToastWrapper from '../ToastWrapper';

import { usePlacesWidget } from 'react-google-autocomplete';
import { trackCleaningAddressInformation } from '../../utils/analytics';

const ACCESS_KEY = '41028a023986b8c8234aa4116ad7bd3a';

type UsState = keyof typeof usStates;
interface BookingAddressInputProps {
  customerExists?: boolean;
  readyForPayment?: any;
}
const BookingAddressInput: React.FC<BookingAddressInputProps> = ({
  customerExists,
  readyForPayment
}: BookingAddressInputProps) => {
  const { lead, dispatchLead } = useLeadContext();
  const [addressLineOne, setAddressLineOne] = useState<string>('');
  const [addressLineTwo, setAddressLineTwo] = useState<string>('');
  const [city, setCity] = useState<string>('');
  const [state, setState] = useState<UsState | string>('AL');
  const [zipCode, setZipCode] = useState<string>('');
  const [showSuggestions, setShowSuggestions] = useState<boolean>(false);
  const [billingAddressLineOne, setBillingAddressLineOne] =
    useState<string>('');
  const [billingAddressLineTwo, setBillingAddressLineTwo] =
    useState<string>('');
  const [suggestedAddressLineOne, setSuggestedAddressLineOne] =
    useState<string>('');
  const [suggestedAddressLineTwo, setSuggestedAddressLineTwo] =
    useState<string>('');
  const [suggestedState, setSuggestedState] = useState<string>('');
  const [suggestedCity, setSuggestedCity] = useState<string>('');
  const [suggestedZipCode, setSuggestedZipCode] = useState<string>('');

  const [billingCity, setBillingCity] = useState<string>('');
  const [billingState, setBillingState] = useState<UsState | string>('');
  const [billingZipCode, setBillingZipCode] = useState<string>('');
  const [sameAddressCheck, setSameAddressCheck] = useState<boolean>(true);
  const [ipAddress, setIpaddress] = useState<string>('');
  const [showModal, setShowModal] = useState<boolean>(false);

  const [showSuccessToast, setShowSuccessToast] = useState<boolean>(false);
  const [showErrorToast, setShowErrorToast] = useState<boolean>(false);
  const [showAddressToast, setShowAddressToast] = useState<boolean>(false);
  const [missingField, setMissingField] = useState<string>('');
  let onlineUserReference;

  const websiteKey = '108521974435358254'; // Your website key here
  const [suggestions, setSuggestions] = useState([]);
  const [key, setKey] = useState(0);
  const { franchisee } = useFranchiseeContext();

  const dispatch = useDispatch();
  const { ref, autocompleteRef } = usePlacesWidget({
    apiKey: 'AIzaSyBEDYnvs7yL93h-50PHvZDQluGcD1uhx1E',
    options: { componentRestrictions: { country: 'us' }, types: ['geocode'] },
    onPlaceSelected: (place) => {
      let addressLineOne = '';
      let city = '';
      let state = '';
      let zipCode = '';

      // Extract the address components from the place object
      const addressComponents = place?.address_components || [];

      // Loop through the address components to find the ones we need
      for (const component of addressComponents) {
        if (component.types.includes('street_number')) {
          addressLineOne += component.long_name + ' ';
        }
        if (component.types.includes('route')) {
          addressLineOne += component.long_name;
        }
        if (component.types.includes('locality')) {
          city = component.long_name;
        }
        if (component.types.includes('administrative_area_level_1')) {
          state = component.short_name;
        }
        if (component.types.includes('postal_code')) {
          zipCode = component.long_name;
        }
      }

      // Set the state variables with the extracted values
      setAddressLineOne(addressLineOne.trim());
      setCity(city);
      setState(state);
      setZipCode(zipCode);
    },
  });

  const { ref: ref2 } = usePlacesWidget({
    apiKey: 'AIzaSyBEDYnvs7yL93h-50PHvZDQluGcD1uhx1E',
    options: { componentRestrictions: { country: 'us' }, types: ['geocode'] },
    onPlaceSelected: (place) => {
      // Handle the selected place for the second input field here
      let addressLineOne = '';
      let city = '';
      let state = '';
      let zipCode = '';

      // Extract the address components from the place object
      const addressComponents = place?.address_components || [];

      // Loop through the address components to find the ones we need
      for (const component of addressComponents) {
        console.log('component', component);
        if (component.types.includes('street_number')) {
          addressLineOne += component.long_name + ' ';
        }
        if (component.types.includes('route')) {
          addressLineOne += component.long_name;
        }
        if (component.types.includes('locality')) {
          city = component.long_name;
        }
        if (component.types.includes('administrative_area_level_1')) {
          state = component.short_name;
        }
        if (component.types.includes('postal_code')) {
          zipCode = component.long_name;
        }
      }

      // Set the state variables with the extracted values
      setBillingAddressLineOne(addressLineOne.trim());
      setBillingCity(city);
      setBillingState(state);
      setBillingZipCode(zipCode);
    },
  });

  useEffect(() => {
    if (!lead) return;
  
    if (lead.addressLineOne) {
      setAddressLineOne(lead.addressLineOne);
    }
  
    if (lead.addressLineTwo) {
      setAddressLineTwo(lead.addressLineTwo);
    }
  
    if (lead.city) {
      setCity(lead.city);
    }
  
    if (lead.state) {
      setState(lead.state);
    }
  
    if (lead.zipCode) {
      setZipCode(lead.zipCode);
    }
  }, [lead]);

  useEffect(() => {
    if (zipCode?.length === 5) {
      if (city === '' || state === '' || addressLineOne === '') {
        setShowAddressToast(true);
        if (city === '') setMissingField('city');
        if (state === '') setMissingField('state');
        if (addressLineOne === '') setMissingField('address');
      } else {
        setShowAddressToast(false);
        setMissingField('');
      }
    }
  }, [zipCode]);

  const [loading, setLoading] = useState<boolean>(false);

  const detectUserAction = () => {
    if (lead?.id === -1) return;
    try {
      onlineUserReference = db.ref(`/online/${lead?.id}`);
      onlineUserReference.update({ typing: true });

      setTimeout(() => {
        onlineUserReference.update({ typing: false });
      }, 500);
    } catch (error) {
      console.log(error);
    }
  };

  const setBillingInformation = async () => {
    try {
      let billingAddress = {};
      if (sameAddressCheck) {
        billingAddress = {
          billingAddressLineOne: addressLineOne,
          billingAddressLineTwo: addressLineTwo,
          billingCity: city,
          billingState: state,
          billingZipCode: zipCode,
          ipAddress,
          sameAddress: true,
        };
      } else {
        billingAddress = {
          billingAddressLineOne,
          billingAddressLineTwo,
          billingCity,
          billingState,
          billingZipCode,
          ipAddress,
          sameAddress: false,
        };
      }
      const response: AxiosResponse = await axios.post(
        '/api/billing-address-session/',
        {
          billingAddress,
        }
      );
      // console.log(response);
    } catch (e) {
      console.log(e);
      Sentry.captureException(e);
    }
  };

  const addressIsReady = (): boolean =>
    validateAddressStringField(addressLineOne) &&
    (validateAddressStringField(addressLineTwo) ||
      addressLineTwo === '' ||
      addressLineTwo === null) &&
    validateAddressStringField(city) &&
    validateUSState(state) &&
    validateZipCode(zipCode);

  const billingAddressIsReady = (): boolean =>
    validateAddressStringField(billingAddressLineOne) &&
    (validateAddressStringField(billingAddressLineTwo) ||
      billingAddressLineTwo === '' ||
      billingAddressLineTwo === null) &&
    validateAddressStringField(billingCity) &&
    validateUSState(billingState) &&
    validateZipCode(billingZipCode);

  const submitAddress = useDebouncedCallback(
    () => {
      if (addressIsReady()) {
        setLoading(true);
        setBillingInformation();
  
        var requestData = {
          leadId: lead.id,
          addressLineOne,
          addressLineTwo: addressLineTwo ?? '',
          city,
          state,
          zipCode,
        };
        // setLeadAddress(requestData)
        axios
          .post('/api/set-lead-address/', requestData)
          .then(({ data, status }) => {
            if (status === 200) {
              dispatchLead({ type: SET_RESIDENCE, payload: data.data.data });
              trackCleaningAddressInformation()
              setShowSuccessToast(true);
            }
            try {
              db.ref(
                process.env.kpiDashboardCollectionName + '/' + lead?.id
              ).update({
                addressLineOne,
                addressLineTwo: addressLineTwo ?? '',
                city,
                state,
                zipCode,
                step: 6,
              });
            } catch (error) {
              console.log(error);
            }
            try {
              const userStatusDatabaseRef = db.ref(`/online/${lead?.id}`);

              db.ref('.info/connected').on('value', async (snap) => {
                if (snap.val() === true) {
                  await userStatusDatabaseRef.onDisconnect().remove();
                  await userStatusDatabaseRef.set({
                    leadID: lead?.id,
                  });
                } else {
                  await userStatusDatabaseRef.remove();
                }
              });
            } catch (error) {
              console.log(error);
            }
          })
          .catch((error) => {
            // console.log(error);
            setShowErrorToast(true);
            Sentry.captureException(error);
          })
          .finally(() => {
            setLoading(false)
            readyForPayment(true)
          });
        
        dispatch(
          setAddress({
            addressLineOne,
            addressLineTwo,
            state,
            city,
            addressZipCode: zipCode,
          })
        );
      }
      detectUserAction();
    },
    2000,
    { trailing: true }
  );

  useEffect(() => {
    if (sameAddressCheck) {
      setBillingInformation();
    } else {
      setBillingInformation();
    }
  }, [sameAddressCheck]);

  const submitBilling = useDebouncedCallback(
    () => {
      if (billingAddressIsReady()) {
        setBillingInformation();
      }
    },
    1100,
    { trailing: true }
  );

  useEffect(submitAddress.callback, [
    addressLineOne,
    addressLineTwo,
    city,
    state,
    zipCode,
    lead.id,
  ]);

  useEffect(submitBilling.callback, [
    billingAddressLineOne,
    billingAddressLineTwo,
    billingCity,
    billingState,
    billingZipCode,
  ]);

  useEffect(() => {
    const getLocation = async () => {
      try {
        const response2: AxiosResponse = await axios.get(
          '/api/user-location-session/'
        );
        const userLocation = response2.data.data.userLocation;
        if (!userLocation.hasOwnProperty('ip')) {
          const result: AxiosResponse = await axios(
            `https://api.ipstack.com/check?access_key=${ACCESS_KEY}`
          );
          setIpaddress(result.data.ip);
          setState(franchisee.state.toUpperCase());
        } else {
          setState(franchisee.state.toUpperCase());
          setIpaddress(userLocation.ip);
        }
      } catch (e) {
        console.log(e);
        Sentry.captureException(e);
      }
    };

    getLocation();
  }, []);

  const useSuggestedAddress = () => {
    setAddressLineOne(suggestedAddressLineOne);
    setZipCode(suggestedZipCode);
    setCity(suggestedCity);
    setState(suggestedState);
    setKey(key + 1); //rerender react typeahed to update value
  };

  const setSuggestedAutoComplete = (suggestion) => {
    // console.log(suggestion);
    setAddressLineOne(suggestion.streetLine);
    setZipCode(suggestion.zipcode);
    setState(suggestion.state);
    setAddressLineTwo(suggestion.secondary);
    setCity(suggestion.city);
    setKey(key + 1); //rerender react typeahed to update value
  };

  return (
    <>
      <Form>
        <Form.Group>
          <p
            className='mb-4'
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <strong className='form-section-header' style={{ flex: 1 }}>
              Cleaning Address
            </strong>
            <SyncLoader color={pink500} size={5} loading={loading} />
          </p>

          <Form.Control
            id='cleaningAddressLine1'
            type='text'
            placeholder='Street Address'
            autoComplete='address-line1'
            name='cleaningAddress[line1]'
            value={addressLineOne}
            ref={ref}
            disabled={customerExists ? true : false}
            style={{ background: customerExists ? '#e9ecef' : '', opacity: customerExists ? '0.5' : '' }}
            onChange={(e) => {
              setAddressLineOne(e.currentTarget.value);
            }}
          />

          <Form.Control.Feedback type='invalid'>
            Please enter a street address.
          </Form.Control.Feedback>
        </Form.Group>
        <Form.Group>
          <Form.Control
            id='cleaningAddressLine2'
            type='text'
            placeholder='Suite or Apartment'
            autoComplete='address-line2'
            name='cleaningAddress[line2]'
            value={addressLineTwo}
            disabled={customerExists ? true : false}
            style={{ background: customerExists ? '#e9ecef' : '', opacity: customerExists ? '0.5' : '' }}
            onChange={(e) => setAddressLineTwo(e.currentTarget.value)}
          />
        </Form.Group>
        <Form.Row className='booking-form-row'>
          <Form.Group className='col-12 col-md'>
            <Form.Control
              type='text'
              id='cleaningAddressCity'
              placeholder='City'
              autoComplete='locality'
              name='cleaningAddress[city]'
              value={city}
              disabled={customerExists ? true : false}
              style={{ background: customerExists ? '#e9ecef' : '', opacity: customerExists ? '0.5' : '' }}
              pattern='[A-Za-z]'
              onChange={(e) => setCity(e.currentTarget.value)}
            />
            <Form.Control.Feedback type='invalid'>
              Please enter a city.
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group className='col-12 col-md booking-state-select'>
            <Form.Control
              as='select'
              id='cleaningAddressState'
              name='cleaningAddress[state]'
              autoComplete='reqion'
              required
              data-billing-target='billingAddress[state]'
              value={state}
              disabled={customerExists ? true : false}
              style={{ background: customerExists ? '#e9ecef' : '', opacity: customerExists ? '0.5' : '', cursor: customerExists ? 'not-allowed' : '' }}
              onChange={(e) => setState(e.currentTarget.value)}
            >
              <StateOptions />
            </Form.Control>
            <Form.Control.Feedback type='invalid'>
              Please select a state.
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group className='col-12 col-md booking-zip-input'>
            <Cleave
              className='form-control'
              placeholder='Zip Code'
              type='tel'
              options={{ numericOnly: true }}
              maxLength={5}
              value={zipCode}
              disabled={customerExists ? true : false}
              style={{ background: customerExists ? '#e9ecef' : '', opacity: customerExists ? '0.5' : '' }}
              autoComplete='postal-code'
              onChange={(e) => {
                setZipCode(e.currentTarget.value);
              }}
            />
            <Form.Control.Feedback type='invalid'>
              Please enter a postal code.
            </Form.Control.Feedback>
          </Form.Group>
        </Form.Row>
      </Form>
      
      <div className='d-flex justify-content-start mt-1'>
        <Form.Check
          aria-label='agree to the terms and conditions'
          onClick={() => setSameAddressCheck(!sameAddressCheck)}
          className='pr-3 confirm-checkbox'
          checked={sameAddressCheck}
          onChange={() => {}}
        />
        <p className='booking-info-text'>
          Billing address is the same as Cleaning Address
        </p>
      </div>
      

      <div
        style={{
          display: sameAddressCheck === false ? 'block' : 'none',
          marginTop: '30px',
        }}
      >
        <Form>
          <Form.Group>
            <p
              className='mt-4 mb-4'
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <strong className='form-section-header' style={{ flex: 1 }}>
                Billing Address
              </strong>
              <SyncLoader color={pink500} size={5} loading={loading} />
            </p>
            <Form.Control
              id='cleaningAddressLine1'
              style={{ border: 'solid 1px var(--grey)' }}
              type='text'
              placeholder='Street Address'
              name='cleaningAddress[line1]'
              autoComplete='address-line1'
              required
              data-billing-target='billingAddress[line1]'
              value={billingAddressLineOne}
              ref={ref2}
              onChange={(e) => setBillingAddressLineOne(e.currentTarget.value)}
            />
            <Form.Control.Feedback type='invalid'>
              Please enter a street address.
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group>
            <Form.Control
              id='cleaningAddressLine2'
              type='text'
              placeholder='Suite or Apartment'
              autoComplete='address-line2'
              name='cleaningAddress[line2]'
              value={billingAddressLineTwo}
              onChange={(e) => setBillingAddressLineTwo(e.currentTarget.value)}
            />
          </Form.Group>
          <Form.Row>
            <Form.Group className='col-12 col-md'>
              <Form.Control
                type='text'
                id='cleaningAddressCity'
                placeholder='City'
                autoComplete='locality'
                name='cleaningAddress[city]'
                value={billingCity}
                pattern='[A-Za-z]'
                onChange={(e) => setBillingCity(e.currentTarget.value)}
              />
              <Form.Control.Feedback type='invalid'>
                Please enter a city.
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group className='col-12 col-md booking-state-select'>
              <Form.Control
                as='select'
                id='cleaningAddressState'
                name='cleaningAddress[state]'
                autoComplete='reqion'
                required
                data-billing-target='billingAddress[state]'
                value={billingState}
                onChange={(e) => setBillingState(e.currentTarget.value)}
              >
                <StateOptions />
              </Form.Control>
              <Form.Control.Feedback type='invalid'>
                Please select a state.
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group className='col-12 col-md booking-zip-input'>
              <Cleave
                className='form-control'
                placeholder='Zip Code'
                type='tel'
                options={{ numericOnly: true }}
                maxLength={5}
                value={billingZipCode}
                autoComplete='postal-code'
                onChange={(e) => {
                  setBillingZipCode(e.currentTarget.value);
                }}
              />
              <Form.Control.Feedback type='invalid'>
                Please enter a postal code.
              </Form.Control.Feedback>
            </Form.Group>
          </Form.Row>
        </Form>
      </div>
      <ToastWrapper>
        <Toast
          show={showAddressToast}
          onClose={() => setShowAddressToast(false)}
          autohide
          delay={8000}
        >
          <Toast.Body className='toast-error'>
            Please enter all address fields. ({missingField})
          </Toast.Body>
        </Toast>
        <Toast
          show={showErrorToast}
          onClose={() => setShowErrorToast(false)}
          autohide
          delay={8000}
        >
          <Toast.Body>
            <ListGroup>
              <ListGroup.Item variant='success'>
                There was an issue updating your information.
              </ListGroup.Item>
            </ListGroup>
          </Toast.Body>
        </Toast>
      </ToastWrapper>

      <Modal
        show={showModal}
        onHide={() => {
          setShowModal(false);
        }}
        aria-labelledby='contained-modal-title-vcenter'
        centered
        style={{ padding: '10px' }}
        scrollable={true}
        className='tac-modal'
      >
        <Modal.Header className='d-flex justify-content-between align-items-center'>
          <Modal.Title style={{ margin: 'auto' }}>Confirm Location</Modal.Title>
          <Button
            onClick={() => setShowModal(false)}
            title='home'
            className='btn btn-sm btn-primary'
          >
            Close
          </Button>
        </Modal.Header>
        <Modal.Body className='px-0'>
          <Section xs={12} lg={12}>
            <Row style={{ justifyContent: 'space-around' }}>
              <Col xs={8} lg={5} xl={5} className='current_address'>
                <p
                  style={{
                    fontWeight: 'bold',
                    fontSize: '20px',
                  }}
                >
                  {' '}
                  Current Address
                </p>
                <div>
                  <p>
                    <span style={{ fontWeight: 'bold' }}>Address : </span>
                    {addressLineOne + ' ' + addressLineTwo}
                  </p>
                  <p>
                    {' '}
                    <span style={{ fontWeight: 'bold' }}>City : </span>
                    {city}
                  </p>
                  <p>
                    {' '}
                    <span style={{ fontWeight: 'bold' }}>State : </span>
                    {state}
                  </p>
                  <p>
                    {' '}
                    <span style={{ fontWeight: 'bold' }}>Zip Code : </span>
                    {zipCode}
                  </p>
                </div>

                <Button
                  variant='primary'
                  onClick={() => {
                    setShowModal(false);
                    setShowSuggestions(false);
                  }}
                >
                  Select
                </Button>
              </Col>

              <Col xs={8} lg={5} xl={5} className='suggested_address'>
                <p
                  style={{
                    fontWeight: 'bold',
                    fontSize: '20px',
                  }}
                >
                  {' '}
                  Suggested Address
                </p>
                <p>
                  {' '}
                  <span style={{ fontWeight: 'bold' }}>Address : </span>
                  {suggestedAddressLineOne}
                </p>
                <p>
                  {' '}
                  <span style={{ fontWeight: 'bold' }}>City : </span>
                  {suggestedCity}
                </p>
                <p>
                  {' '}
                  <span style={{ fontWeight: 'bold' }}>State: </span>
                  {suggestedState}
                </p>
                <p>
                  {' '}
                  <span style={{ fontWeight: 'bold' }}>Zip Code : </span>
                  {suggestedZipCode}
                </p>
                <Button
                  variant='primary'
                  onClick={() => {
                    setShowModal(false);
                    useSuggestedAddress();
                    setShowSuggestions(false);
                  }}
                >
                  Select
                </Button>
              </Col>
            </Row>
          </Section>
        </Modal.Body>
        {/* <Modal.Footer>
          <Button variant='primary' onClick={() => setShowModal(false)}>
            Submit
          </Button>
        </Modal.Footer> */}
      </Modal>
    </>
  );
};

export default BookingAddressInput;
